var M = (s) => {
  throw TypeError(s);
};
var j = (s, t, e) => t.has(s) || M("Cannot " + e);
var r = (s, t, e) => (j(s, t, "read from private field"), e ? e.call(s) : t.get(s)), x = (s, t, e) => t.has(s) ? M("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, e), y = (s, t, e, a) => (j(s, t, "write to private field"), a ? a.call(s, e) : t.set(s, e), e), g = (s, t, e) => (j(s, t, "access private method"), e);
import * as l from "react";
import { g as K } from "./mutation-Csa9eQDM.js";
import { S as L, s as T, h as E, n as k, g as z, i as P, k as V } from "./hook-pPrHCB6G.js";
import { j as o } from "./jsx-runtime-C5mzlN2N.js";
import * as i from "@radix-ui/react-select";
import { ChevronDown as U, ChevronUp as G, Check as q } from "lucide-react";
import { c as p } from "./cn-qaFjX9_3.js";
var h, m, n, c, u, N, C, I, A = (I = class extends L {
  constructor(t, e) {
    super();
    x(this, u);
    x(this, h);
    x(this, m);
    x(this, n);
    x(this, c);
    y(this, h, t), this.setOptions(e), this.bindMethods(), g(this, u, N).call(this);
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(t) {
    var a;
    const e = this.options;
    this.options = r(this, h).defaultMutationOptions(t), T(this.options, e) || r(this, h).getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: r(this, n),
      observer: this
    }), e != null && e.mutationKey && this.options.mutationKey && E(e.mutationKey) !== E(this.options.mutationKey) ? this.reset() : ((a = r(this, n)) == null ? void 0 : a.state.status) === "pending" && r(this, n).setOptions(this.options);
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || (t = r(this, n)) == null || t.removeObserver(this);
  }
  onMutationUpdate(t) {
    g(this, u, N).call(this), g(this, u, C).call(this, t);
  }
  getCurrentResult() {
    return r(this, m);
  }
  reset() {
    var t;
    (t = r(this, n)) == null || t.removeObserver(this), y(this, n, void 0), g(this, u, N).call(this), g(this, u, C).call(this);
  }
  mutate(t, e) {
    var a;
    return y(this, c, e), (a = r(this, n)) == null || a.removeObserver(this), y(this, n, r(this, h).getMutationCache().build(r(this, h), this.options)), r(this, n).addObserver(this), r(this, n).execute(t);
  }
}, h = new WeakMap(), m = new WeakMap(), n = new WeakMap(), c = new WeakMap(), u = new WeakSet(), N = function() {
  var e;
  const t = ((e = r(this, n)) == null ? void 0 : e.state) ?? K();
  y(this, m, {
    ...t,
    isPending: t.status === "pending",
    isSuccess: t.status === "success",
    isError: t.status === "error",
    isIdle: t.status === "idle",
    mutate: this.mutate,
    reset: this.reset
  });
}, C = function(t) {
  k.batch(() => {
    var e, a, d, w, f, S, R, O;
    if (r(this, c) && this.hasListeners()) {
      const b = r(this, m).variables, v = r(this, m).context;
      (t == null ? void 0 : t.type) === "success" ? ((a = (e = r(this, c)).onSuccess) == null || a.call(e, t.data, b, v), (w = (d = r(this, c)).onSettled) == null || w.call(d, t.data, null, b, v)) : (t == null ? void 0 : t.type) === "error" && ((S = (f = r(this, c)).onError) == null || S.call(f, t.error, b, v), (O = (R = r(this, c)).onSettled) == null || O.call(
        R,
        void 0,
        t.error,
        b,
        v
      ));
    }
    this.listeners.forEach((b) => {
      b(r(this, m));
    });
  });
}, I);
function et(s, t) {
  const e = z(t), [a] = l.useState(
    () => new A(
      e,
      s
    )
  );
  l.useEffect(() => {
    a.setOptions(s);
  }, [a, s]);
  const d = l.useSyncExternalStore(
    l.useCallback(
      (f) => a.subscribe(k.batchCalls(f)),
      [a]
    ),
    () => a.getCurrentResult(),
    () => a.getCurrentResult()
  ), w = l.useCallback(
    (f, S) => {
      a.mutate(f, S).catch(P);
    },
    [a]
  );
  if (d.error && V(a.options.throwOnError, [d.error]))
    throw d.error;
  return { ...d, mutate: w, mutateAsync: d.mutate };
}
const st = i.Root, at = i.Group, rt = i.Value, Q = l.forwardRef(({ className: s, children: t, ...e }, a) => /* @__PURE__ */ o.jsxs(
  i.Trigger,
  {
    ref: a,
    className: p(
      "flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      s
    ),
    ...e,
    children: [
      /* @__PURE__ */ o.jsx("span", { className: "truncate", children: t }),
      /* @__PURE__ */ o.jsx(i.Icon, { asChild: !0, children: /* @__PURE__ */ o.jsx(U, { className: "flex-shrink-0 h-4 w-4 opacity-50" }) })
    ]
  }
));
Q.displayName = i.Trigger.displayName;
const B = l.forwardRef(({ className: s, ...t }, e) => /* @__PURE__ */ o.jsx(
  i.ScrollUpButton,
  {
    ref: e,
    className: p(
      "flex cursor-default items-center justify-center py-1",
      s
    ),
    ...t,
    children: /* @__PURE__ */ o.jsx(G, { className: "h-4 w-4" })
  }
));
B.displayName = i.ScrollUpButton.displayName;
const D = l.forwardRef(({ className: s, ...t }, e) => /* @__PURE__ */ o.jsx(
  i.ScrollDownButton,
  {
    ref: e,
    className: p(
      "flex cursor-default items-center justify-center py-1",
      s
    ),
    ...t,
    children: /* @__PURE__ */ o.jsx(U, { className: "h-4 w-4" })
  }
));
D.displayName = i.ScrollDownButton.displayName;
const F = l.forwardRef(({ className: s, children: t, position: e = "popper", ...a }, d) => /* @__PURE__ */ o.jsx(i.Portal, { children: /* @__PURE__ */ o.jsxs(
  i.Content,
  {
    ref: d,
    className: p(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      s
    ),
    position: e,
    ...a,
    children: [
      /* @__PURE__ */ o.jsx(B, {}),
      /* @__PURE__ */ o.jsx(
        i.Viewport,
        {
          className: p(
            e === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]",
            "divide-y"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ o.jsx(D, {})
    ]
  }
) }));
F.displayName = i.Content.displayName;
const H = l.forwardRef(({ className: s, ...t }, e) => /* @__PURE__ */ o.jsx(
  i.Label,
  {
    ref: e,
    className: p("py-1.5 pl-8 pr-2 text-sm font-semibold", s),
    ...t
  }
));
H.displayName = i.Label.displayName;
const J = l.forwardRef(({ className: s, children: t, ...e }, a) => /* @__PURE__ */ o.jsxs(
  i.Item,
  {
    ref: a,
    className: p(
      "relative flex w-full cursor-default select-none items-center py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      s
    ),
    ...e,
    children: [
      /* @__PURE__ */ o.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ o.jsx(i.ItemIndicator, { children: /* @__PURE__ */ o.jsx(q, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ o.jsx(i.ItemText, { children: t })
    ]
  }
));
J.displayName = i.Item.displayName;
const W = l.forwardRef(({ className: s, ...t }, e) => /* @__PURE__ */ o.jsx(
  i.Separator,
  {
    ref: e,
    className: p("-mx-1 my-1 h-px bg-muted", s),
    ...t
  }
));
W.displayName = i.Separator.displayName;
export {
  st as S,
  Q as a,
  rt as b,
  F as c,
  at as d,
  J as e,
  et as u
};
//# sourceMappingURL=Select-Dg5R11Dx.js.map
